import { render, staticRenderFns } from "./MarginsMarginTable.vue?vue&type=template&id=725eab86&"
import script from "./MarginsMarginTable.vue?vue&type=script&lang=js&"
export * from "./MarginsMarginTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/MarginsMarginTable.vue
// module id = null
// module chunks = 